<div class="container">
    <mat-toolbar color="primary" class="mat-elevation-z6">
        <button mat-button (click)="sidenav.toggle()">
            <mat-icon>menu</mat-icon>
        </button>
        <button mat-button routerLink="/" class="home-link">
            <mat-icon>shopping_basket</mat-icon>
            <span>Account</span>
        </button>

        <!-- This fills the remaining space of the current row -->
        <span class="fill-remaining-space"></span>

        <button mat-button [matMenuTriggerFor]="menu" class="avatar">
            <mat-icon>account_circle</mat-icon>
        </button>
        <mat-menu #menu="matMenu">
            <span mat-menu-item>{{user?.name}}</span>
            <button mat-menu-item (click)="signOut()">Sign out</button>
            <span mat-menu-item>version: {{version}}</span>
        </mat-menu>
    </mat-toolbar>
    <mat-sidenav-container>
        <mat-sidenav #sidenav mode="over">
            <a mat-button routerLink="/timeline" (click)="sidenav.toggle()">
                <mat-icon>view_list</mat-icon>
                タイムライン
            </a>
            <a mat-button routerLink="/accounts/new" (click)="sidenav.toggle()">
                <mat-icon>add</mat-icon>
                新規登録
            </a>
            <a mat-button routerLink="/dashboard" (click)="sidenav.toggle()">
                <mat-icon>dashboard</mat-icon>
                確定する
            </a>
            <a mat-button routerLink="/accounts/archived" (click)="sidenav.toggle()">
                <mat-icon>history</mat-icon>
                過去分を見る
            </a>
        </mat-sidenav>
        <mat-sidenav-content>
            <router-outlet *ngIf="user; else loading"></router-outlet>
            <ng-template #loading>
                <div style="display:flex;align-items:center;justify-content:center;height:80vh;">
                    <mat-spinner diameter="150" color="accent"></mat-spinner>
                </div>
            </ng-template>
        </mat-sidenav-content>
    </mat-sidenav-container>
</div>